import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Row, Column, Container } from '@comparethemarketau/manor-grid';
import { Typography } from '@comparethemarketau/manor-typography';

import { ProductsSortSelect } from './common/products_sort_select';
import { resultsPricesNoticeText, resultsPricesGSTText } from '../disclaimers/results_prices_notice/results_prices_notice_xs';

import { ContainerWrapper } from '../container_wrapper';

const useStyles = createUseStyles((theme) => ({
    notice: {
        color: theme.colors.grey700,
        fontSize: theme.fontSize.sm
    },
    noticeGst: {
        extend: 'notice',
        display: 'inline-block'
    }
}));

const PolicySortsSm = ({ padding }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <ContainerWrapper padding={padding} className={'test-policySorts-sm'}>
            <Container>
                <Row removeMarginBottom>
                    <Column valign="flex-start" halign="center" cols={8}>
                        <Typography className={classes.notice}>
                            {`${resultsPricesNoticeText} `}
                            <span className={classes.noticeGst}>{resultsPricesGSTText}</span>
                        </Typography>
                    </Column>
                    <Column valign="flex-end" halign="flex-end" cols={4}>
                        <ProductsSortSelect />
                    </Column>
                </Row>
            </Container>
        </ContainerWrapper>
    );
};

PolicySortsSm.propTypes = {
    padding: PropTypes.array
};

export { PolicySortsSm };
